import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getUserData } from 'store/selectors/user';
import { useCreateSurveyMutation } from 'store/services/feedbackGroup';
import Button from 'style-guide/Button';
import Form from 'style-guide/Form';
import FormItem from 'style-guide/FormItem';
import { Input } from 'style-guide/Input';
import CreateSurveyModalWrapper from './style/CreateSurveyModalWrapper';

const CreateSurveyModal = ({ hideModal }) => {
  const { register, handleSubmit } = useForm({
    mode: 'onChange',
  });

  const navigate = useNavigate();

  const user = useSelector(getUserData);

  const [createSurvey, { data }] = useCreateSurveyMutation();

  useEffect(() => {
    if (data?.id) {
      navigate(`/survey/create/introduction/${data.id}`);
    }
  }, [data, navigate]);

  const onFormSubmit = (formData) => {
    createSurvey({ title: formData.surveyName, userId: user.id, statusId: 1 });
  };

  return (
    <CreateSurveyModalWrapper>
      <Form onSubmit={handleSubmit(onFormSubmit)}>
        <FormItem name='surveyName' label='Survey name'>
          <Input {...register('surveyName')} />
        </FormItem>
        <div className='d-flex justify-content-end'>
          <Button className='mr--8' variant='secondary' onClick={hideModal}>
            Cancel
          </Button>
          <Button variant='primary' type='submit'>
            Save
          </Button>
        </div>
      </Form>
    </CreateSurveyModalWrapper>
  );
};

export default CreateSurveyModal;
